import { Card, Space, Table, Input, Button, Flex } from 'antd';
import { PlusSquareOutlined } from "@ant-design/icons";
import { useOrderEditContext } from './OrderEditContext';

const { Search } = Input;

const ProductPickerPanel = () => {
    const { openProductPicker, setOpenProductPicker, filterProducts, setProductFilterValue, onAddProduct } = useOrderEditContext();

    const productColumns = [
        {
            title: 'Sản phẩm',
            render: (record) => {
                return (
                    <>
                        {record.product.name} {record.variant_title}
                    </>
                )
            }
        },
        {
            title: '',
            render: (record) => {
                return (
                    <>
                        <Button type='link' onClick={e => onAddProduct(record.id)}><PlusSquareOutlined />Thêm </Button>
                    </>
                )
            }
        },
    ];

    return (
        <>
            <Flex style={{ marginTop: 8 }} justify='flex-end'>
                {!openProductPicker &&
                    <Button type="link" onClick={e => setOpenProductPicker(true)} style={{ width: 150 }}>Thêm sản phẩm</Button>
                }
            </Flex>

            <Card title="Thêm sản phẩm" size='small' style={{ display: openProductPicker ? "block" : "none", marginTop: 8 }} extra={<Button type='link' onClick={e => setOpenProductPicker(false)}>Close</Button>}>
                <Space direction='vertical' style={{ width: "100%" }}>
                    <Search onChange={e => setProductFilterValue("info", e.target.value)} />
                    <Table columns={productColumns} dataSource={filterProducts} scroll={{ y: 400 }} />
                </Space>
            </Card>
        </>
    )
}

export default ProductPickerPanel;
